import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GroupI } from '../../../interfaces/groups/group.interface';
import { UserI } from '../../../interfaces/users/user.interface';
import { GroupsService } from '../../../services/groups.service';
import { MessageService } from '../../../services/message.service';
import { UsersService } from '../../../services/users.service';

@Component({
  selector: 'app-add-user-group',
  templateUrl: './add-user-group.component.html',
  styleUrls: ['./add-user-group.component.scss']
})
export class AddUserGroupComponent implements OnInit {

  @Input() group: GroupI;
  @Output() groupSubmit = new EventEmitter();
  @Output() closeModal = new EventEmitter();

  // TODO: temporal en lo que el back hace la desición
  public users: UserI[];
  public usersInGroup: UserI[];
  public availableUsers: UserI[];

  public picketUser: UserI;

  public loadingUser = false;

  constructor(
    private messageService: MessageService,
    private groupServ: GroupsService,
    public userServ: UsersService
  ) {
  }

  ngOnInit(): void {
    this.loadAllUsers();
  }

  loadAllUsers() {
    this.loadingUser = true;
    this.userServ.getEnableToLink().subscribe(res => {
      if (res.ok === true) {
        this.availableUsers = res.users;

        this.loadingUser = false;
      }
    }, error => {
      this.loadingUser = false;
      console.log(error);
    })
  }

  processUser(user: UserI) {
    let data = {
      group_id: this.group.id,
      user_id: user.id
    }

    this.groupServ.addUserToGroup(data).subscribe(res => {
      if (res.ok === true) {
        this.messageService.printStatus(res.message, 'success');
        this.groupSubmit.emit(true);
      }
    }, error => {
      this.messageService.printStatusArray(error.error.errors, 'error');
      console.log(error);
    })
  }

  onClose() {
    this.closeModal.emit();
  }
}
